import { Box, ButtonBase, styled } from '@material-ui/core';
import { distances } from '@setvi/shared/styles';
import { facetMarginBottom } from '..';

export const facetContentPaddingBottom = distances.small;

export const Container = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  marginBottom: facetMarginBottom,
  borderRadius: 12,
  overflow: 'hidden'
}));

export const FacetContentContainer = styled(Box)({
  padding: `0 ${facetContentPaddingBottom}px`
});

export const FacetButton = styled(ButtonBase)({
  width: '100%',
  padding: `${distances.px.small} ${distances.px.base}`,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)'
  }
});
